import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { PackageProfile } from "src/models";
import { StringService, _ } from "src/services";
import { ModalsAction, Packages, PackagesAction, UserSession } from "src/store";

export const PackageProfileBox: React.FC<PackageProfile> = ({ id, partner, amount, durationType, discountAmount, payableAmount, discountPercent }) => {

    //#region dependencies

    const dispatch = useDispatch();
    const { programId } = useParams<any>();
    const packages: Packages = useSelector((state: any) => state.PackagesState);
    const user: UserSession = useSelector((state: any) => state.UserState);

    //#endregion

    //#region methods

    const onCreateOrder = () => {
        if (packages.loading) return;
        if (!user.loggedIn) {
            dispatch(ModalsAction.showLogin());
            return;
        }
        dispatch(PackagesAction.createOrder(id, +programId));
    };


    //#endregion

    return (
        <div className="package-profile px-3 py-4 my-3 d-flex align-items-center"
            style={partner ? { background: `linear-gradient(264deg, #252626, ${partner.colorCode} 152%)` } : {}}
        >
            <div className="d-flex flex-column align-items-start flex-1">
                <h3 className="payment-box__title">
                    <span>{durationType}</span>
                    {
                        partner &&
                        <>
                            <span className="px-2">+</span>
                            <span style={{ color: partner.colorCode }}>{partner.productName} {partner.partnerName}</span>
                        </>
                    }
                </h3>
                <div className="price d-flex align-items-center">
                    {
                        discountAmount > 0 &&
                        <>
                            <div className="package-profile__discount-price">{StringService.toPrice(amount)} {_("currency")}</div>
                            <span className="package-profile__discount mx-2">٪{discountPercent}</span>
                        </>
                    }
                    <span className="d-block green-fcolor text-right">{StringService.toPrice(payableAmount)} {_("currency")}</span>
                </div>
            </div>
            <button className="btn btn-packages" disabled={packages.loading} onClick={onCreateOrder}>
                {_("select")}
            </button>
        </div>
    );

};